import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { BusinessProductPaymentManagerPage } from '../business-product-payment-manager/business-product-payment-manager';
import { BusinessProductPaymentInvoiceListPage } from '../business-product-payment-invoice-list/business-product-payment-invoice-list';
import { BusinessProductExpediterInvoiceListPage } from '../business-product-expediter-invoice-list/business-product-expediter-invoice-list';
import { ConsumerProfilePage } from '../../pages/consumer-profile/consumer-profile';
import { BusinessUserOrderListPage } from '../business-user-order-list/business-user-order-list';
import { BusinessProductSearchPage } from '../business-product-search/business-product-search';

@Component({
  selector: 'page-cashier-main',
  templateUrl: 'cashier-main.html',
})
export class CashierMainPage {
  cashier = BusinessProductSearchPage;
  openOrders = BusinessProductExpediterInvoiceListPage;
  invoices = BusinessProductPaymentInvoiceListPage;
  profile = ConsumerProfilePage;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ExpeditorMainPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/cashier-main/cashier-main.ts